// Translations
import landing from '../views/landing/translations/ua'

// Translation: Error (Ukrainian)
export default Object.freeze({
	name: '',
	views: { landing }
})
